import script from "./ListPage.vue?vue&type=script&lang=ts"
export * from "./ListPage.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__